import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-x",
  width: "19",
  height: "19",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2",
  fill: "white",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1)

import NavigationButton from "@/features/shared/NavigationButton.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationCloseButton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigationButton, null, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})